import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelDetailDrawerSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.HeaderContainer>
        <Styles.HeaderTitleContainer>
          <Styles.HeaderInfoContainer>
            <Skeleton variant="text" width={120} height={24} />
            <Skeleton variant="rounded" width={40} height={20} />
            <Skeleton variant="rounded" width={90} height={20} />
            <Skeleton variant="circular" width={20} height={20} />
          </Styles.HeaderInfoContainer>
          <Skeleton variant="rounded" width={175} height={34} />
        </Styles.HeaderTitleContainer>
        <Styles.HeaderStatusContainer>
          <Skeleton variant="rounded" width={140} height={24} />
          <Skeleton variant="text" width={200} height={16} />
          <Skeleton variant="text" width={160} height={14} />
        </Styles.HeaderStatusContainer>
      </Styles.HeaderContainer>

      <Styles.CustomDivider />

      <Skeleton variant="text" width={140} height={24} />
      <Styles.ShippingDetailsContainer>
        {Array.from({ length: 6 }).map((_, index) => (
          <Styles.InfoRow key={index}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width={120} height={16} />
            <Skeleton variant="text" width={180} height={16} />
          </Styles.InfoRow>
        ))}
      </Styles.ShippingDetailsContainer>

      <Styles.CustomDivider />

      <Skeleton variant="text" width={100} height={24} />
      <Styles.ProductsContainer>
        {Array.from({ length: 2 }).map((_, index) => (
          <Styles.ProductRow key={index}>
            <Skeleton variant="rounded" width={64} height={64} />
            <Styles.ProductInfo>
              <Skeleton variant="text" width={180} height={18} />
              <Skeleton variant="text" width={120} height={14} />
              <Skeleton variant="text" width={80} height={14} />
            </Styles.ProductInfo>
          </Styles.ProductRow>
        ))}
      </Styles.ProductsContainer>

      <Styles.CustomDivider />

      <Skeleton variant="text" width={130} height={24} />
      <Styles.CostContainer>
        {Array.from({ length: 3 }).map((_, index) => (
          <Styles.CostRow key={index}>
            <Skeleton variant="text" width={100} height={16} />
            <Skeleton variant="text" width={60} height={16} />
          </Styles.CostRow>
        ))}
      </Styles.CostContainer>

      <Styles.CustomDivider />

      <Skeleton variant="text" width={110} height={24} />
      <Styles.DocumentsContainer>
        {Array.from({ length: 2 }).map((_, index) => (
          <Styles.DocumentRow key={index}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="rounded" width={220} height={20} />
            <Skeleton variant="circular" width={20} height={20} />
          </Styles.DocumentRow>
        ))}
      </Styles.DocumentsContainer>
    </Styles.Container>
  )
}

export default ParcelDetailDrawerSkeleton
